// extracted by mini-css-extract-plugin
export default {"form":"Form_form__H1+it","inputWrapper":"Form_inputWrapper__Xcg8o","checkbox":"Form_checkbox__F5a7d","privacyPolicy":"Form_privacyPolicy__07zlx","row":"Form_row__uBkVz"};